export class BookingContact {
  public Type: string; //IC=Brukare, ZZ=Förskrivare
  public Name: string;
  public Phone: string;
  public Extra: string;
}
